import React from 'react';
import { Reveal } from './Reveal';
import { Counter } from './Counter';
import { stats } from '../data/site';
export function StatsBar() {
  return <section aria-label="Company statistics" className="w-full border-b border-ink-800 bg-ink" data-id="element-331" data-mp="1tb9sg5fd9x9p">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-332" data-mp="1o9keagwul3he">
        <ul className="grid divide-y divide-white/10 sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4 lg:divide-x" data-id="element-333" data-mp="1jd3rbq1dwv5w">
          {stats.map((stat, i) => <li key={stat.headline} data-id="element-334" data-mp="1ef26azkeelrs" data-mpi={i}>
              <Reveal delay={i * 0.05} className="px-0 py-10 lg:px-10 lg:py-14" data-id="element-335" data-mp="19lzditng3gcn">
                <p className="font-display text-4xl font-extrabold tracking-tightest text-white lg:text-5xl" data-id="element-336" data-mp="15knsl1finjas">
                  {stat.text ? stat.text : <Counter target={stat.value ?? 0} suffix={stat.suffix ?? ''} data-id="element-337" data-mp="vmgfwus9fnel" />}
                </p>
                <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.18em] text-ice-400" data-id="element-338" data-mp="qnd9b5wmt94i">{stat.headline}</p>
                <p className="mt-1.5 text-sm text-white/55" data-id="element-339" data-mp="3onc230hqtsr3">{stat.label}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}